
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconPaperclipSelector = "fhi-icon-paperclip";

@customElement(FhiIconPaperclipSelector)
export class FhiIconPaperclip extends LitElement {
  @property({ type: String }) color: string = "currentcolor";

  @property({ type: Number }) size: number = 24;

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this.size}" height="${this.size}" fill="${this.color}"><path d="M15.731 1.439c1.269.074 2.436.668 3.3 1.53.862.864 1.456 2.031 1.53 3.3.071 1.206-.331 2.451-1.324 3.545l-.207.216-8.5 8.5c-.644.644-1.412.919-2.168.874-.737-.043-1.404-.386-1.892-.873-.488-.488-.831-1.156-.874-1.893-.045-.756.23-1.524.874-2.168l8.5-8.5a.75.75 0 1 1 1.06 1.06l-8.5 8.5c-.356.357-.455.713-.437 1.02.019.325.175.658.437.92s.595.418.92.438c.307.017.664-.082 1.02-.438l8.5-8.5.154-.161c.737-.81.986-1.667.94-2.452-.05-.857-.457-1.69-1.094-2.327s-1.47-1.044-2.327-1.094c-.785-.046-1.642.203-2.452.94l-.16.155-8.5 8.5c-1.357 1.355-1.831 2.837-1.75 4.207.08 1.387.737 2.72 1.75 3.732 1.011 1.012 2.344 1.668 3.732 1.75 1.369.08 2.85-.394 4.207-1.75l9.5-9.5a.75.75 0 1 1 1.06 1.06l-9.5 9.5c-1.644 1.644-3.537 2.294-5.355 2.187-1.8-.106-3.467-.948-4.705-2.186s-2.081-2.906-2.187-4.706c-.107-1.818.543-3.711 2.187-5.355l8.5-8.5.216-.207c1.094-.993 2.339-1.395 3.545-1.324"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
